import { createFileRoute } from "@tanstack/react-router"
import { ChangeEmailPage } from "@/pages/ChangeEmailPage"

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings/security/change-email"
)({
  component: ChangeEmailPage,
})
